import React, { Component } from "react";
import { func, shape, bool, string } from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import TransactionTicket from "pages/_components/TransactionTicket";

import { selectors as echeqSelector, actions as echeqActions } from "reducers/checks";
import { actions as formActions } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as statusActions } from "reducers/status";
import { selectors as transactionsSelectors, actions as transactionsActions } from "reducers/transactions";
import { selectors as frequentDestinationSelectors } from "reducers/frequentDestination";
import * as i18n from "util/i18n";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { resolveEmbeddedV3GoBackPath } from "util/v3ShellLayoutSync";
import { getDebitAccountTicketLabel } from "util/accounts";
import EmitMassiveSummaryData from "./EmitMassiveSummaryData";

const FORM_ID = "echeq.massive.emit";
const EXTERNAL_MASSIVE_EMIT_ACTIVITY = "external.emit.massive.echeq.activity";

function getEmitMassiveTicketTitleKey(summary) {
    return summary?.idActivity === EXTERNAL_MASSIVE_EMIT_ACTIVITY
        ? "activities.external.emit.massive.echeq.activity"
        : "echeq.massive.emit";
}

/** Título del comprobante PDF: externo masivo en dos líneas centradas en el Jasper. */
function getEmitMassivePdfTicketName(summary) {
    if (summary?.idActivity === EXTERNAL_MASSIVE_EMIT_ACTIVITY) {
        return `${i18n.get("activities.external.emit.massive.echeq.activity.pdfTitleLine1")}\n${i18n.get(
            "activities.external.emit.massive.echeq.activity.pdfTitleLine2",
        )}`;
    }
    return i18n.get(getEmitMassiveTicketTitleKey(summary));
}
class EmitMassiveTicket extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        summary: shape({}).isRequired,
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
        goBackEmitMassive: bool.isRequired,
        embeddedInV3Shell: bool,
        lastHrefPathname: string,
        transactionRoute: string,
        location: shape({
            pathname: string,
        }),
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        lastHrefPathname: "",
        transactionRoute: "/desktop",
        location: undefined,
    };

    state = {
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { summary, dispatch, location } = this.props;
        if (location) {
            dispatch(statusActions.saveLastHref(location));
        }
        if (!summary?.idTransaction && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        } else {
            dispatch(echeqActions.setRememberMassiveData(false));
            dispatch(transactionsActions.getPotentialSignaturesData(summary.idTransaction));
        }
    }

    componentDidUpdate(prevProps) {
        const { location, dispatch } = this.props;
        if (location && prevProps.location?.pathname !== location.pathname) {
            dispatch(statusActions.saveLastHref(location));
        }
    }

    centerContentMobile = () => {
        const { summary } = this.props;
        const titleKey = getEmitMassiveTicketTitleKey(summary);
        return (
            <div className="title-account-header-multiline-background-blue">
                <h1 className="w-100 m-0 px-2">{i18n.get(titleKey)}</h1>
            </div>
        );
    };

    handleDownload = async () => {
        this.setState({ fetchingDownload: true });
        const { dispatch, summary } = this.props;
        const ticketData = {
            ticketName: getEmitMassivePdfTicketName(summary),
            ticketBody: [...this.generateTicketBody()],
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    generateTicketBody = () => {
        const { summary } = this.props;

        return [
            getGeneralTicketItem(`forms.transaction.ticket.date`, summary?.submitDateTime, "datefulltime"),
            getGeneralTicketItem(`${FORM_ID}.summary.idBatch.label`, summary?.batchId, "string"),
            getGeneralTicketItem(
                `${FORM_ID}.summary.account.label`,
                summary?.account?.number !== undefined && getDebitAccountTicketLabel(summary?.account),
                "string",
            ),
            getGeneralTicketItem(`${FORM_ID}.summary.batchReference.label`, summary?.reference, "string"),
            getGeneralTicketItem(`${FORM_ID}.summary.processDate.label`, summary?.processDate, "datefulltime"),
            getGeneralTicketItem(`${FORM_ID}.summary.fileName.label`, summary?.file?.fileName, "string"),
            getGeneralTicketItem(`${FORM_ID}.summary.quantity.label`, summary?.echeqsQuantity, "string"),
            getGeneralTicketItem(`${FORM_ID}.summary.totalAmount.label`, summary?.amountToShow.quantity, "amountARS"),
        ];
    };

    buttonsDetail = () => {
        const { dispatch } = this.props;
        const buttons = [
            {
                label: `${FORM_ID}.ticket.goTo.echeqMassive`,
                bsStyle: "primary",
                onClick: () => {
                    dispatch(echeqActions.setEcheqOption("emitted.massive.echeq"));
                    dispatch(push("/echeqs"));
                },
            },
        ];

        return buttons;
    };

    signTransaction = () => {
        const { dispatch, summary, isDesktop, location } = this.props;
        const { idActivity } = summary;
        const titleKey = getEmitMassiveTicketTitleKey(summary);
        const goBackState = location?.pathname
            ? `${location.pathname}${location.search || ""}`
            : "/echeqs/emit/massive";

        const signTransactionData = (
            <EmitMassiveSummaryData isDesktop={isDesktop} summary={summary} FORM_ID={FORM_ID} spaceBetween signature />
        );

        dispatch(push({ pathname: "/transactions/sign", state: { goBackState } }));
        dispatch(
            formActions.signTransactionData({
                idTransaction: summary?.idTransaction,
                idActivity,
                idForm: "",
                content: signTransactionData,
                title: titleKey,
                pendingDispatch: summary?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity,
                idTransaction: summary.idTransaction,
                idForm: "",
                ticketData: summary,
            }),
        );
        dispatch(echeqActions.checksRequestData({ ...summary, action: "sign" }));
    };

    render() {
        const {
            isDesktop,
            summary,
            fetching,
            embeddedInV3Shell,
            goBackEmitMassive,
            lastHrefPathname,
            transactionRoute,
            location,
        } = this.props;
        const { showDrawerMobile, fetchingDownload } = this.state;
        const summaryTitleKey = getEmitMassiveTicketTitleKey(summary);

        const isFinished = summary.idTransactionStatus === "FINISHED";

        const currentPath = location?.pathname || "";
        const savedTransactionRoute =
            typeof transactionRoute === "string" && transactionRoute.startsWith("/") && transactionRoute !== currentPath
                ? transactionRoute
                : null;

        const flowBaseForBack = goBackEmitMassive ? "/echeqs/emit/massive" : savedTransactionRoute || "/echeqs";
        const resolvedBackPath = resolveEmbeddedV3GoBackPath(flowBaseForBack, lastHrefPathname);

        const handleBack = () => {
            const { dispatch } = this.props;
            dispatch(echeqActions.cleanEcheqAction());
            dispatch(push(resolvedBackPath));
        };

        return (
            <TransactionTicket
                embeddedInV3Shell={embeddedInV3Shell}
                embeddedV3GoBackPath={flowBaseForBack}
                notificationScope="echeqs"
                handleBack={handleBack}
                handleClick={this.handleDownload}
                handleClickMessage="global.download"
                headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                centerElement={isDesktop ? undefined : this.centerContentMobile}
                uniqueDownload={isFinished}
                hasInlineButtons
                hideMobileMenu={!isDesktop}
                summary={summary}
                buttonsDetail={this.buttonsDetail()}
                isDesktop={isDesktop}
                fetching={fetching}
                onSignTicket={this.signTransaction}
                summaryTitle={summaryTitleKey}
                closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                showDrawerMobile={showDrawerMobile}
                isFetchingExport={fetchingDownload}
                ignoreHomeButton
                downloadImageWhite={!isDesktop}>
                <EmitMassiveSummaryData isDesktop={isDesktop} summary={summary} FORM_ID={FORM_ID} spaceBetween />
            </TransactionTicket>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: echeqSelector.getTransactionEcheqData(state),
    fetching: echeqSelector.getFetching(state),
    potentialSignaturesData: transactionsSelectors.getPotentialSignaturesData(state),
    loggedUser: sessionSelectors.getUser(state),
    frequentDestination: frequentDestinationSelectors.getFrequentDestination(state),
    idEnvironment: frequentDestinationSelectors.getEnviromentId(state),
    goBackEmitMassive: echeqSelector.getGoBackEmitMassive(state),
    lastHrefPathname: (state.status?.lastHref && state.status.lastHref.pathname) || "",
    transactionRoute: transactionsSelectors.getTransactionRoute(state) || "/desktop",
});

export default connect(mapStateToProps)(EmitMassiveTicket);
